"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = shouldSpeakIncomingActivity;

var _startSpeakingActivity = require("../actions/startSpeakingActivity");

var _stopSpeakingActivity = require("../actions/stopSpeakingActivity");

function shouldSpeakIncomingActivity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type;

  switch (type) {
    case _startSpeakingActivity.START_SPEAKING_ACTIVITY:
      state = true;
      break;

    case _stopSpeakingActivity.STOP_SPEAKING_ACTIVITY:
      state = false;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1Y2Vycy9zaG91bGRTcGVha0luY29taW5nQWN0aXZpdHkuanMiXSwibmFtZXMiOlsic2hvdWxkU3BlYWtJbmNvbWluZ0FjdGl2aXR5Iiwic3RhdGUiLCJ0eXBlIiwiU1RBUlRfU1BFQUtJTkdfQUNUSVZJVFkiLCJTVE9QX1NQRUFLSU5HX0FDVElWSVRZIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7O0FBRWUsU0FBU0EsMkJBQVQsR0FBOEQ7QUFBQSxNQUF6QkMsS0FBeUIsdUVBQWpCLEtBQWlCOztBQUFBO0FBQUEsTUFBUkMsSUFBUSxRQUFSQSxJQUFROztBQUMzRSxVQUFRQSxJQUFSO0FBQ0UsU0FBS0MsOENBQUw7QUFDRUYsTUFBQUEsS0FBSyxHQUFHLElBQVI7QUFDQTs7QUFFRixTQUFLRyw0Q0FBTDtBQUNFSCxNQUFBQSxLQUFLLEdBQUcsS0FBUjtBQUNBOztBQUVGO0FBQ0U7QUFWSjs7QUFhQSxTQUFPQSxLQUFQO0FBQ0QiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTVEFSVF9TUEVBS0lOR19BQ1RJVklUWSB9IGZyb20gJy4uL2FjdGlvbnMvc3RhcnRTcGVha2luZ0FjdGl2aXR5JztcbmltcG9ydCB7IFNUT1BfU1BFQUtJTkdfQUNUSVZJVFkgfSBmcm9tICcuLi9hY3Rpb25zL3N0b3BTcGVha2luZ0FjdGl2aXR5JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2hvdWxkU3BlYWtJbmNvbWluZ0FjdGl2aXR5KHN0YXRlID0gZmFsc2UsIHsgdHlwZSB9KSB7XG4gIHN3aXRjaCAodHlwZSkge1xuICAgIGNhc2UgU1RBUlRfU1BFQUtJTkdfQUNUSVZJVFk6XG4gICAgICBzdGF0ZSA9IHRydWU7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgU1RPUF9TUEVBS0lOR19BQ1RJVklUWTpcbiAgICAgIHN0YXRlID0gZmFsc2U7XG4gICAgICBicmVhaztcblxuICAgIGRlZmF1bHQ6XG4gICAgICBicmVhaztcbiAgfVxuXG4gIHJldHVybiBzdGF0ZTtcbn1cbiJdfQ==